import { render, staticRenderFns } from "./clientCommissionCreate.vue?vue&type=template&id=dd006b02&"
import script from "./clientCommissionCreate.vue?vue&type=script&lang=js&"
export * from "./clientCommissionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports